import ModalViewModel from 'infra/ModalViewModel'
import Job from 'jobs/Job'
import JobStore from 'jobs/JobStore'
import { action, computed, observable, makeObservable } from 'mobx'
import { DateZero } from 'utils/date-util'
import { toStream } from 'utils/mobx-util'
import { whileActive } from 'utils/rx-util'
import { task } from 'mobx-task'
import { startOfDay } from 'date-fns'

/**
 * Start Date view model.
 */
export default class StartDateViewModel extends ModalViewModel {
  @observable startDate: Date = DateZero()
  @observable reason = ''

  constructor(public job: Job, private jobStore: JobStore) {
    super()
    makeObservable(this)
  }

  /**
   * Shows the modal.
   */
  show() {
    this.reason = ''
    // When the start date is updated (realtime), update the draft value.
    toStream(() => this.job.dateStart, true)
      .pipe(whileActive(this.showing$))
      .subscribe(this.setStartDate)
    super.show()
  }

  /**
   * Sets the start date.
   * @param value
   */
  @action.bound
  setStartDate(value: Date | null) {
    this.startDate = startOfDay(value || new Date())
  }

  /**
   * Whether it is possible to change the start date.
   */
  @computed
  get canSaveStartDate() {
    if (!this.job.dateStart) {
      return true
    }

    return startOfDay(this.job.dateStart).valueOf() !== this.startDate.valueOf()
  }

  /**
   * Saves the start date.
   */
  save = task.resolved(async () => {
    await this.jobStore.changeStartDate(this.job, {
      newStartDate: this.startDate,
      reason: this.reason,
    })
    this.close()
  })
}
